import { useEffect, useState } from "react";
import Filter from "./Filter";
import * as F from "./FilterList.styles";
import { useRouter } from "next/router";
import { connect } from "react-redux";
import FilteredList from "./FilteredList";

const FilterList = (props) => {
  const { dummyList, productList, addCart, inCart } = props;
  const router = useRouter();
  const [viewType, setViewType] = useState("");
  const [filteredList, setFilteredList] = useState([]);
  const [filters, setFilters] = useState({});
  const handleListViewType = (type) => {
    if (viewType === type) {
      return;
    }
    localStorage.setItem("P_viewType", type);
    setViewType(type);
  };

  const { page, ...queries } = router.query;
  // 필터 라우팅
  const handleQuery = (type, value) => {
    sessionStorage.setItem(
      `__next_scroll_${router.pathname}`,
      JSON.stringify({
        x: window.scrollX,
        y: window.scrollY,
      })
    );

    if (type === "sizes") {
      const { sizes, ...rest } = queries;
      router.push({
        pathname: "",
        query: {
          ...rest,
        },
      });
      return;
    }

    const prevQuery = queries[type];
    let query = "";

    if (prevQuery && prevQuery.split(" ").includes(value)) {
      // 이미 선택된 값이면 제거
      const tempArr = prevQuery.split(" ");
      const idx = tempArr.findIndex((el) => el === value);
      tempArr.splice(idx, 1);
      query = tempArr.join(" ");
    } else {
      // 새 값 추가 - 모든 타입에서 다중 선택 허용
      if (queries[type]) {
        query = `${prevQuery} ${value}`;
      } else {
        query = value;
      }
    }

    if (!queries[type]) {
      router.push({
        pathname: "",
        query: {
          ...queries,
          [type]: value,
        },
      });
    } else {
      router.push({
        pathname: "",
        query: {
          ...queries,
          [type]: query,
        },
      });
    }
  };

  // 필터 만들기
  const getFilters = () => {
    // 1. 먼저 전체 제품에서 사용 가능한 카테고리 추출
    const productsCate = [];
    productList.forEach((el) => {
      if (!productsCate.includes(el.category_code)) {
        productsCate.push(el.category_code);
      }
    });

    // 2. 카테고리 필터 생성
    const categories = dummyList?.category?.filter((el) =>
      productsCate.includes(el.code)
    );

    const categoryFilter = {
      type: "category_code",
      name: "카테고리",
      values: categories
        ? categories.map((el) => ({ name: el.name, value: el.code }))
        : [],
    };

    // 3. 선택된 카테고리에 따라 제품 필터링
    let filteredProducts = productList;

    // 선택된 카테고리가 있으면 해당 카테고리 상품만 필터링
    if (queries.category_code) {
      const selectedCategories = queries.category_code.split(" ");
      filteredProducts = productList.filter((product) =>
        selectedCategories.includes(product.category_code)
      );
    }

    // 4. 필터링된 제품에서 세부 카테고리와 주원료 추출
    const productsHash = [];
    const productsFeature = [];

    filteredProducts.forEach((el) => {
      // 세부 카테고리 추출
      if (el.category_tag && !productsHash.includes(el.category_tag)) {
        productsHash.push(el.category_tag);
      }

      // 주원료 추출
      if (
        el.feature &&
        el.feature !== "" &&
        !productsFeature.includes(el.feature)
      ) {
        productsFeature.push(el.feature);
      }
    });

    // 5. 세부 카테고리 필터 생성
    let categoryTagFilter = {
      type: "category_tag",
      name: "세부 카테고리",
      values: [],
    };

    if (productsHash.length > 0) {
      const tempArr = [];
      productsHash.forEach((hashs) => {
        hashs?.split(",").forEach((el) => {
          if (!tempArr.includes(el)) tempArr.push(el);
        });
      });

      categoryTagFilter.values = tempArr.map((el) => ({ name: el, value: el }));
    }

    // 6. 주원료 필터 생성
    let featureFilter = {
      type: "feature",
      name: "주원료",
      values: [],
    };

    if (productsFeature.length > 0) {
      featureFilter.values = productsFeature.map((el) => ({
        name: el,
        value: el,
      }));
    }

    // 7. 필터 상태 업데이트
    setFilters({
      ...filters,
      category_code: categoryFilter,
      category_tag: categoryTagFilter,
      feature: featureFilter,
    });
  };

  // queries로 필터 적용
  const filtering = () => {
    if (
      Object.keys(router.query) &&
      Object.values(router.query).filter((el) => el != "").length > 0
    ) {
      const query = queries;
      const filterKeys = Object.keys(queries);
      let tempList = productList;

      filterKeys.forEach((key) => {
        if (!query[key] || query[key] === "") return;

        tempList = tempList.filter((el) => {
          if (!query[key]) return true;

          if (key === "sizes") {
            const { height, horizontal, range, vertical } = JSON.parse(
              query.sizes
            );
            if (
              (horizontal > 0 &&
                Number(horizontal) - Number(range) <= Number(el.horizontal) &&
                Number(el.horizontal) <= Number(horizontal) + Number(range)) ||
              (vertical > 0 &&
                Number(vertical) - Number(range) <= Number(el.vertical) &&
                Number(el.vertical) <= Number(vertical) + Number(range)) ||
              (height > 0 &&
                Number(height) - Number(range) <= Number(el.height) &&
                Number(el.height) <= Number(height) + Number(range))
            ) {
              return true;
            }
            return false;
          } else if (key === "category_code") {
            // 카테고리 다중 선택 처리
            const selectedCategories = query[key].split(" ");
            return (
              selectedCategories.includes(el[key]) ||
              selectedCategories.length === 0
            );
          } else if (key === "category_tag") {
            // 세부 카테고리 다중 선택 처리
            if (query[key] === "") return true;

            const selectedTags = query[key].split(" ");
            const productTags = el[key].split(",");

            // 선택된 태그 중 하나라도 제품 태그에 포함되면 포함
            return (
              selectedTags.some((tag) => productTags.includes(tag)) ||
              selectedTags.length === 0
            );
          } else if (key === "feature") {
            // 주원료 다중 선택 처리
            if (query[key] === "") return true;

            const selectedFeatures = query[key].split(" ");
            return (
              selectedFeatures.includes(el[key]) ||
              selectedFeatures.length === 0
            );
          } else {
            // 기타 필터링
            const selectedValues = query[key].split(" ");
            return (
              selectedValues.includes(el[key]) || selectedValues.length === 0
            );
          }
        });
      });

      setFilteredList(tempList);
    } else {
      setFilteredList(productList);
    }
  };

  const handleSizeFilter = (sizes) => {
    const { height, horizontal, range, vertical } = sizes;
    if (sizes) {
      sessionStorage.setItem(
        `__next_scroll_${router.pathname}`,
        JSON.stringify({
          x: window.scrollX,
          y: window.scrollY,
        })
      );
      router.push({
        pathname: "",
        query: {
          ...queries,
          sizes: JSON.stringify(sizes),
        },
      });
    }
  };

  useEffect(() => {
    if (!router.isReady) return;

    if (localStorage.getItem("P_viewType")) {
      setViewType(localStorage.getItem("P_viewType"));
    } else {
      setViewType("list");
    }

    const routeChangeCompleteHandler = () => {
      // 페이지 이동 후 저장되어 있던 위치로 스크롤 복원
      const _scroll = sessionStorage.getItem(
        `__next_scroll_${router.pathname}`
      );
      if (_scroll) {
        // 스크롤 복원 후 저장된 위치 제거
        const { x, y } = JSON.parse(_scroll);
        window.scrollTo(x, y);
        sessionStorage.removeItem(`__next_scroll_${router.pathname}`);
      }
    };

    router.events.on("routeChangeComplete", routeChangeCompleteHandler);
    return () => {
      router.events.off("routeChangeComplete", routeChangeCompleteHandler);
    };
  }, [router.isReady]);

  useEffect(() => {
    if (!productList || !dummyList) return;
    getFilters();
    filtering();
  }, [productList, dummyList, router.query]);

  // 페이지 진입 시 쿼리 초기화를 위한 코드 추가
  useEffect(() => {
    if (!router.isReady) return;

    const isPrintPage = router.pathname.includes("/print");
    const hasNoQuery = Object.keys(router.query).length === 0;

    // viewType 로컬스토리지 값 복원
    const savedViewType = localStorage.getItem("P_viewType");
    setViewType(savedViewType || "list");

    const routeChangeCompleteHandler = () => {
      const _scroll = sessionStorage.getItem(
        `__next_scroll_${router.pathname}`
      );
      if (_scroll) {
        const { x, y } = JSON.parse(_scroll);
        window.scrollTo(x, y);
        sessionStorage.removeItem(`__next_scroll_${router.pathname}`);
      }
    };

    router.events.on("routeChangeComplete", routeChangeCompleteHandler);
    return () => {
      router.events.off("routeChangeComplete", routeChangeCompleteHandler);
    };
  }, [router.isReady]);

  return (
    <>
      <F.FilterListSection>
        <Filter
          handleQuery={handleQuery}
          filters={filters}
          queries={queries}
          handleSizeFilter={handleSizeFilter}
        />
        <FilteredList
          viewType={viewType}
          handleListViewType={handleListViewType}
          dummyList={dummyList}
          filteredList={filteredList}
          addCart={addCart}
          inCart={inCart}
        />
      </F.FilterListSection>
    </>
  );
};

const mapStateToProps = (state) => ({
  dummyList: state.dummyList,
});

export default connect(mapStateToProps, null)(FilterList);
